// @ts-nocheck
export const MLB_REVEAL_CONFIG = {
  charDelay: 35,
  lineGap: 30,
  startDelay: 200
};

/* 创建一个逐字揭示控制器。
     * options:
     *   segments: [{ el, cursor }]  顺序揭示的段；el 为承载文字的元素（文字取自 data-text 或现有 textContent），cursor 为可选的跟随光标元素
     *   onComplete: 全部揭示完成回调
     * 返回 { init, destroy }
     */
    export function createMlbReveal (options) {
      var cfg = MLB_REVEAL_CONFIG;
      var segments = options.segments || [];
      var onComplete = options.onComplete;

      var timers = [];        // 所有 setTimeout 句柄，destroy 时清理
      var built = false;      // 是否已拆字
      var segData = [];       // 每段拆出的 { el, cursor, chars:[span], text }

      function clearTimers() {
        for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
        timers = [];
      }

      // 把一段文字拆成 .mlb-char span（保留空格宽度），全部就位但隐藏
      function buildSegment(seg) {
        var el = seg.el;
        var text = el.getAttribute('data-text');
        if (text === null) text = el.textContent || '';
        el.textContent = '';
        var chars = [];
        for (var i = 0; i < text.length; i++) {
          var span = document.createElement('span');
          span.className = 'mlb-char';
          // 空格用 \u00a0 占位，确保 inline-block 有宽度
          span.textContent = text[i] === ' ' ? '\u00a0' : text[i];
          el.appendChild(span);
          chars.push(span);
        }
        // 渐变在首行「美团智播数字人」(hero-title-1)；需整句连续渐变
        var isGrad = !!(el.closest && el.closest('.hero-title-1'));
        return { el: el, cursor: seg.cursor || null, chars: chars, text: text, isGrad: isGrad };
      }

      // 让渐变段的每个字共用「整句」坐标系：写入整句宽度与该字的水平偏移，
      // 使各字裁出的渐变片段拼起来是一条连续渐变。需在字已就位（占好宽度）后调用。
      function applyGradientCoords(s) {
        if (!s.isGrad || !s.chars.length) return;
        // 以第一个字的左边为整句原点
        var baseLeft = s.chars[0].offsetLeft;
        var last = s.chars[s.chars.length - 1];
        var totalW = (last.offsetLeft + last.offsetWidth) - baseLeft;
        if (totalW <= 0) return;
        s.chars.forEach(function (span) {
          var x = span.offsetLeft - baseLeft;  // 该字相对整句的左偏移
          span.style.setProperty('--mlb-grad-w', totalW + 'px');
          // 渐变整体相对该字向左移 x，使该字露出的是整句渐变在 x 处的片段
          span.style.setProperty('--mlb-grad-x', (-x) + 'px');
        });
      }

      // 让光标跟在某个字之后（插入到该 char 的下一个兄弟位置）
      function moveCursorAfter(cursor, charSpan) {
        if (!cursor) return;
        if (cursor.classList.contains('cursor-blink') && charSpan && charSpan.parentNode) {
          var parent = charSpan.parentNode;
          parent.style.position = 'relative';
          parent.style.display = 'inline-block';
          parent.appendChild(cursor);
          cursor.style.position = 'absolute';
          cursor.style.left = (charSpan.offsetLeft + charSpan.offsetWidth) + 'px';
          cursor.style.top = '50%';
          cursor.style.marginLeft = '6px';
          cursor.style.transform = 'translateY(-44%)';
          return;
        }
        if (charSpan && charSpan.parentNode) {
          charSpan.parentNode.insertBefore(cursor, charSpan.nextSibling);
        }
      }

      function moveCursorBefore(cursor, charSpan) {
        if (!cursor || !charSpan || !charSpan.parentNode) return;
        if (cursor.classList.contains('cursor-blink')) {
          var parent = charSpan.parentNode;
          parent.style.position = 'relative';
          parent.style.display = 'inline-block';
          parent.appendChild(cursor);
          cursor.style.position = 'absolute';
          cursor.style.left = charSpan.offsetLeft + 'px';
          cursor.style.top = '50%';
          cursor.style.marginLeft = '6px';
          cursor.style.transform = 'translateY(-44%)';
          return;
        }
        charSpan.parentNode.insertBefore(cursor, charSpan);
      }

      function init() {
        if (built) return;
        built = true;

        // 1) 先全部拆字、就位（占好宽度，避免揭示时抖动）
        segData = segments.map(buildSegment);

        // 1.5) 渐变段：按整句坐标系给每个字写入渐变偏移，拼成连续渐变
        segData.forEach(applyGradientCoords);

        // 2) 把所有光标先藏起来，揭到哪段再显示哪段的光标
        segData.forEach(function (s) {
          if (s.cursor) s.cursor.classList.add('cursor-hidden');
        });

        // 3) 逐字打字机：每个字瞬间直出（opacity 0→1 无过渡），光标跟随
        var elapsed = cfg.startDelay;
        segData.forEach(function (s, si) {
          // 段开始：显示本段光标，把上一段光标藏起
          timers.push(setTimeout((function (seg, idx) {
            return function () {
              segData.forEach(function (other, oi) {
                if (other.cursor) {
                  if (oi === idx) other.cursor.classList.remove('cursor-hidden');
                  else other.cursor.classList.add('cursor-hidden');
                }
              });
              // 段开头先把光标放到第一个字之前
              if (seg.cursor && seg.chars[0]) {
                moveCursorBefore(seg.cursor, seg.chars[0]);
              }
            };
          })(s, si), elapsed));

          // 逐个字揭示，光标跟到该字之后
          s.chars.forEach(function (charSpan, ci) {
            timers.push(setTimeout((function (span, seg) {
              return function () {
                span.classList.add('mlb-visible');
                moveCursorAfter(seg.cursor, span);
              };
            })(charSpan, s), elapsed + ci * cfg.charDelay));
          });

          elapsed += s.chars.length * cfg.charDelay + cfg.lineGap;
        });

        // 4) 全部揭示完成回调
        timers.push(setTimeout(function () {
          // 打完后保持最后活跃光标可见
          var lastCursor = null;
          segData.forEach(function (s) {
            if (s.cursor) {
              s.cursor.classList.add('cursor-hidden');
              lastCursor = s.cursor;
            }
          });
          // 最后一个光标保持显示
          if (lastCursor) lastCursor.classList.remove('cursor-hidden');
          if (typeof onComplete === 'function') onComplete();
        }, elapsed));
      }

      function destroy() {
        clearTimers();
        // 还原各段文字与光标位置
        segData.forEach(function (s) {
          s.el.textContent = s.text;
          if (s.cursor) {
            s.cursor.classList.remove('cursor-hidden');
            s.el.parentNode && s.el.parentNode.appendChild(s.cursor);
          }
        });
        built = false;
        segData = [];
      }

      /* ============================================================
       * 扩展能力：把控制器变成「可正放/可倒放、光标双向跟随」的引擎
       * ============================================================ */

      // 确保已拆字就位（但全部隐藏、不播放）。返回是否本次新建。
      function ensureBuilt() {
        if (built) return false;
        built = true;
        segData = segments.map(buildSegment);
        segData.forEach(applyGradientCoords);
        segData.forEach(function (s) {
          if (s.cursor) s.cursor.classList.add('cursor-hidden');
        });
        return true;
      }

      // 主光标：多段共享同一光标时取第一个非空的
      function getCursor() {
        for (var i = 0; i < segData.length; i++) {
          if (segData[i].cursor) return segData[i].cursor;
        }
        return null;
      }

      // 按显示顺序拼接所有字符 span
      function getChars() {
        var all = [];
        segData.forEach(function (s) {
          for (var i = 0; i < s.chars.length; i++) all.push(s.chars[i]);
        });
        return all;
      }

      // 瞬时全显（无逐字动画）：用于"应处于完整态"的初始/兜底场景
      function showAllInstant() {
        ensureBuilt();
        getChars().forEach(function (c) { c.classList.add('mlb-visible'); });
        var cur = getCursor();
        if (cur) cur.classList.add('cursor-hidden');
      }

      // 瞬时全隐（无逐字动画）
      function hideAllInstant() {
        ensureBuilt();
        getChars().forEach(function (c) { c.classList.remove('mlb-visible'); });
        var cur = getCursor();
        if (cur) cur.classList.add('cursor-hidden');
      }

      // 正向逐字出现 + 光标前进。每个字瞬间直出。
      // speedOverride: 可选，覆盖 charDelay（ms），用于步骤切换时加速。
      var playing = false;
      function playReveal(onDone, speedOverride) {
        ensureBuilt();
        clearTimers();
        playing = true;
        var delay = (typeof speedOverride === 'number') ? speedOverride : cfg.charDelay;
        var chars = getChars();
        var cur = getCursor();
        // 起步：所有字隐藏，光标显示并落在第一个字之前
        chars.forEach(function (c) { c.classList.remove('mlb-visible'); });
        if (cur) {
          cur.classList.remove('cursor-hidden');
          if (chars[0] && chars[0].parentNode) {
            moveCursorBefore(cur, chars[0]);
          }
        }
        chars.forEach(function (span, ci) {
          timers.push(setTimeout(function () {
            span.classList.add('mlb-visible');
            moveCursorAfter(cur, span); // 光标跟到刚打出的字之后
          }, ci * delay));
        });
        timers.push(setTimeout(function () {
          playing = false;
          if (cur) cur.classList.add('cursor-hidden'); // 打完收起光标
          if (typeof onDone === 'function') onDone();
        }, chars.length * delay + 40));
      }

      // 逆序逐字消失 + 光标回退。从末尾往前一个个隐去。
      function playHide(onDone) {
        ensureBuilt();
        clearTimers();
        playing = true;
        var chars = getChars();
        var cur = getCursor();
        var N = chars.length;
        // 消失节奏：相邻字间隔取出现间隔的一半，使「逐字消失」整体快 2 倍
        var hideDelay = cfg.charDelay / 2;
        if (cur) {
          cur.classList.remove('cursor-hidden');
          if (chars[N - 1]) moveCursorAfter(cur, chars[N - 1]);
        }
        for (var k = 0; k < N; k++) {
          var idx = N - 1 - k; // 从末尾往前
          timers.push(setTimeout((function (i) {
            return function () {
              chars[i].classList.remove('mlb-visible');
              if (cur) {
                if (i > 0) moveCursorAfter(cur, chars[i - 1]);
                else if (chars[0] && chars[0].parentNode) moveCursorBefore(cur, chars[0]);
              }
            };
          })(idx), k * hideDelay));
        }
        timers.push(setTimeout(function () {
          playing = false;
          if (cur) cur.classList.add('cursor-hidden');
          if (typeof onDone === 'function') onDone();
        }, N * hideDelay + 40));
      }

      function isPlaying() { return playing; }

      return {
        init: init,
        destroy: destroy,
        ensureBuilt: ensureBuilt,
        getCursor: getCursor,
        getChars: getChars,
        showAllInstant: showAllInstant,
        hideAllInstant: hideAllInstant,
        playReveal: playReveal,
        playHide: playHide,
        isPlaying: isPlaying
      };
    };

export function setupMlbRevealGlobal() {
  if (typeof window !== 'undefined') {
    window.MLB_REVEAL_CONFIG = MLB_REVEAL_CONFIG;
    window.createMlbReveal = createMlbReveal;
  }
}
